import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { AIDisclosureResultState } from '../type/ai-disclosure.type';

export const AIDisclosureResultModel = Symbol('AIDisclosureResultModel');

export interface AIDisclosureResultModel extends AbstractModel<AIDisclosureResultState> {
}

@injectable()
export class AIDisclosureResultModelImpl extends AbstractModelImpl<AIDisclosureResultState> implements AIDisclosureResultModel {
    protected _modelData: AIDisclosureResultState = {
        title: '',
        settings: {
            inventionSubject: [],
            applicationField: [],
            techMeans: '',
            techEffect: '',
            other: '',
            recommendInventionSubject: [],
            recommendApplicationField: [],
        },
        hidden: [],
        disclosureResult: [],
    };
}
